<template>
  <div>
    <Academic v-model="model" @result="getBack" />
    <SubjectGrading
      v-model="model"
      :grade-definitions="gradeDefinitions"
      :subjects="subjects"
      :validate="errors"
    />
    <div class="row mt-3">
      <div class="col-md-12 text-right">
        <ts-button class="mr-2" @click.prevent="$emit('close')">{{
          $t('cancel')
        }}</ts-button>
        <ts-button
          class="mr-2"
          color="primary"
          outline
          @click.prevent="saveNew"
          :waiting="waiting_new"
          >{{ $t('save_add_new') }}</ts-button
        >
        <ts-button
          class="mr-2"
          color="primary"
          @click.prevent="save"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import Academic from './component/academic'
import SubjectGrading from './component/subject-grading'

export default {
  name: 'subjectGradingFormCreate',
  components: {
    Academic,
    SubjectGrading
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      gradeDefinitions: [],
      subjects: [],
      waiting: false,
      waiting_new: false,
      model: {
        acp_id: null,
        acps_id: null,
        level_id: null,
        grade_id: null,
        definition_type: 'Grading',
        is_percentage: false,
        enable_semester: false,
        enable_sciense: false,
        subject_score_grading_list: []
      },
      sendData: {
        subject_score_grading_list: []
      }
    }
  },
  methods: {
    ...mapActions('subjectGradingRange', ['store', 'update']),
    save() {
      if (this.createdDataBeforeSend()) {
        this.waiting = true
        this.store(this.sendData)
          .then(response => {
            this.$toasted.success(response.message)
            this.$parent.show_form = false
            this.$emit('fetch')
            this.clearInput()
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    saveNew() {
      if (this.createdDataBeforeSend()) {
        this.waiting_new = true
        this.store(this.sendData)
          .then(response => {
            this.$toasted.success(response.message)
            this.clearInput()
            this.$emit('fetch')
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting_new = false
          })
      }
    },
    clearInput() {
      this.errors = new Errors()
      this.model.is_percentage = false
      this.model.enable_semester = false
      this.model.subject_score_grading_list = []
      this.sendData = { subject_score_grading_list: [] }
      this.$children[1].selectedSubject = []
      this.$children[1].fetchCreated()
    },
    getBack(record) {
      this.gradeDefinitions = record.gradeDefinitions
      this.subjects = record.subjects
    },
    createdDataBeforeSend() {
      if (!this.$children[1].selectedSubject.length > 0) {
        this.$toasted.error('Please select subject before submit.')
        return false
      }
      this.sendData = {
        is_percentage: this.model.is_percentage,
        enable_semester: this.model.enable_semester,
        enable_sciense: this.model.enable_sciense,
        subject_score_grading_list: this.$children[1].selectedSubject
          .map(el => {
            return this.model.subject_score_grading_list.map(item =>
              Object.assign({}, item, { grade_subject_id: el })
            )
          })
          .flat()
      }
      return true
    }
  },
  watch: {
    'model.level_id': function(id) {
      this.subjects = []
    }
  }
}
</script>
